import React from "react";
import {
  IconSchool,
  IconRobot,
  IconBrandWhatsapp,
  IconMessageCircle,
  IconChevronRight,
} from "@tabler/icons-react";

// ===============================================
// FLUXO DE CRIACAO
// ===============================================

const FLOW_STEPS = [
  { icon: IconSchool, label: "Aprender" },
  { icon: IconRobot, label: "Criar Agente" },
  { icon: IconBrandWhatsapp, label: "Conectar" },
  { icon: IconMessageCircle, label: "Atender" },
];

// ===============================================
// AGENTS STEP COMPONENT
// ===============================================

const AgentsStep = () => {
  return (
    <>
      <div className="onb-card__header">
        <h2 className="onb-card__title">Agentes de IA</h2>
        <p className="onb-card__subtitle">
          Onde a mágica acontece
        </p>
      </div>

      <div className="onb-card__body">
        <p className="onb-card__text">
          Aqui você cria e gerencia seus agentes de atendimento com
          inteligência artificial. O fluxo ideal para começar é:
        </p>

        <div className="onb-flow">
          {FLOW_STEPS.map((step, index) => (
            <React.Fragment key={index}>
              <div className="onb-flow__step">
                <step.icon size={14} />
                {step.label}
              </div>
              {index < FLOW_STEPS.length - 1 && (
                <IconChevronRight size={14} className="onb-flow__arrow" />
              )}
            </React.Fragment>
          ))}
        </div>

        <p className="onb-card__text">
          Antes de criar seu primeiro agente, assista as aulas de
          <strong> Criação de Agentes</strong> no Aprendizado. Ela vai te
          economizar horas de ajustes e garantir um agente muito mais
          eficiente.
        </p>
      </div>
    </>
  );
};

export default AgentsStep;
